import React from 'react'
import { withIcon } from '../../withIcon'

function CaretDownOutlineIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M12.0669 16.553C11.8228 16.8049 11.4271 16.8049 11.183 16.553L5.18304 10.3594C5.00429 10.1749 4.95082 9.89742 5.04756 9.65634C5.1443 9.41526 5.37219 9.25807 5.62498 9.25807L17.625 9.25807C17.8778 9.25807 18.1057 9.41526 18.2024 9.65634C18.2991 9.89742 18.2457 10.1749 18.0669 10.3594L12.0669 16.553ZM16.1161 10.5484L7.13386 10.5484L11.625 15.1844L16.1161 10.5484Z" fill={color}/>
    </svg>
  )
}

export default withIcon(CaretDownOutlineIcon)
